/* Tirvela scroll reveal — adds .is-visible to .trv-rev when in viewport.
   Respects prefers-reduced-motion. Idempotent — safe to load multiple times. */
(function () {
  if (window.__trvRevealInit) return;
  window.__trvRevealInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var els = document.querySelectorAll('.trv-rev:not(.is-visible)');
    if (!els.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on section reload (Shopify theme editor)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
